export default "__VITE_ASSET__CuB38UpR__"